import React from "react";
import { withTranslation } from "react-i18next";
import { Icon } from "semantic-ui-react";

import { getInterventionPriceWithVAT, round2 } from "../../../../../../util/common";
import QuestionResultStatus from "../../../QuestionResultStatus";
import LabelBadge from "../../../LabelImages/components/LabelBadge";
import { getImageLabel } from "../../../../util";

import "./index.scss";

const InterventionItem = ({ intervention, settings, t }) => {
  const displayInterventionPrice = intervention => {
    if (!settings.dms_price_enabled) return null;

    const price = settings.include_vat ? getInterventionPriceWithVAT(intervention, settings) : intervention.price;

    return <span className="intervention-price">€ {round2(price).toFixed(2)}</span>;
  };

  const imageLabel = getImageLabel(intervention.images);

  const title = intervention.title?.trim() || "";
  const description = intervention.description?.trim() || "";

  const stackDescription = Boolean(description) && (description.length > 46 || title.length > 34 || title.length + description.length > 62);

  return (
    <div
      className={`interventions-row ${stackDescription ? "interventions-row--stacked" : ""} ${
        imageLabel ? "interventions-row--with-badge" : "interventions-row--no-badge"
      }`}
    >
      <div className="interventions-row-top">
        <div className="interventions-cell interventions-cell--main">
          <div className="interventions-main-wrap">
            <div className="interventions-main-icon-cell">
              {!isNaN(intervention.question_result_status) ? (
                <QuestionResultStatus status={intervention.question_result_status} />
              ) : (
                <span className="interventions-left-icon">
                  <Icon name="desktop" size="tiny" />
                </span>
              )}
            </div>

            <div className="interventions-main-text-cell">
              <div className="interventions-inline-flow">
                <span className="interventions-title">{title}</span>

                {!stackDescription && description && <span className="interventions-inline-description">{description}</span>}
              </div>
            </div>
          </div>
        </div>

        <div className="interventions-cell interventions-cell-price">{displayInterventionPrice(intervention)}</div>

        <div className="interventions-cell interventions-cell-actions">
          {imageLabel && (
            <span className="interventions-cell-badge checks-cell-badge">
              <LabelBadge label={imageLabel} />
            </span>
          )}

          <span className="interventions-cell--status">
            <span className="interventions-icon interventions-icon-status">
              {intervention.customer_ok ? <Icon name="check circle" className="customer-ok-icon" /> : <Icon name="remove circle" className="customer-not-ok-icon" />}
            </span>

            <span className="interventions-icon">
              <Icon name="wrench" className={`rotate-270 ${intervention.mechanic_fixed ? "mechanic-fixed-icon" : "mechanic-not-fixed-icon"}`} />
            </span>
          </span>
        </div>
      </div>

      {stackDescription && description && <div className="interventions-description-block">{description}</div>}
    </div>
  );
};

export default withTranslation()(InterventionItem);
